// Versão exibida ao cliente em todo o painel: sidebar (perto da logo),
// badge do diagrama de conexão e página de Changelog. É a fonte única da verdade —
// ao sair uma release, bumpar aqui e manter o package.json em sincronia.
export const APP_VERSION = '3.7.0'

// Versão que controla o popup "Novidades". Só avançamos este número quando há uma
// feature grande que justifique interromper o cliente com o modal. Releases de
// melhoria/ajuste (que sobem APP_VERSION) não reabrem o popup — por isso ele fica defasado de propósito.
export const MODAL_VERSION = '3.7.0'

export const STORAGE_KEY_APP_VERSION = 'appVersion'
export const STORAGE_KEY_APP_VERSION_VIEWS = 'appVersionViews'
export const MAX_MODAL_VIEWS = 3

const getVersionLocalStorage = () => {
  return window.localStorage.getItem(STORAGE_KEY_APP_VERSION)
}

const saveVersionLocalStorage = (version) => {
  window.localStorage.setItem(STORAGE_KEY_APP_VERSION, version)
}

const getModalViewCount = () => {
  return parseInt(window.localStorage.getItem(STORAGE_KEY_APP_VERSION_VIEWS) || '0', 10)
}

const incrementModalViewCount = () => {
  const count = getModalViewCount() + 1
  window.localStorage.setItem(STORAGE_KEY_APP_VERSION_VIEWS, String(count))
  return count
}

const resetModalViewCount = () => {
  window.localStorage.setItem(STORAGE_KEY_APP_VERSION_VIEWS, '0')
}

export default {
  getVersionLocalStorage,
  saveVersionLocalStorage,
  getModalViewCount,
  incrementModalViewCount,
  resetModalViewCount
}